import 'vite/modulepreload-polyfill';
import {initVueApp} from '@/init';
import axios from 'axios';
import {createApp} from 'vue';
import App from './App.vue';
import './directives';
import './filters';
import './init';
import {exportDefaultRoute, exportedIntranetDomain, exportToken} from './library/export';
import router, {hash} from './router';
import './stylesheet/export.scss';
import 'ol/ol.css';

// @ts-ignore
window.__toCdnUrl = (filename) => exportedIntranetDomain() + '/dist/' + filename;

// @ts-ignore
window.portunaInitExport = () => {
    // axios defaults
    axios.defaults.headers['X-Requested-By'] = 'spa-export';
    axios.defaults.headers['X-Export-Token'] = exportToken();
    axios.defaults.baseURL                   = exportedIntranetDomain();

    // do NOT export/import a Vue instance!
    const app = createApp(App);
    initVueApp(app);
    app.mount('#app-' + exportToken());

    let to = hash.replace('#', '');
    if (to.charAt(0) !== '/')
    {
        to = '';
    }

    if ((!to || to === '/') && window.location.search)
    {
        let search = window.location.search;

        try {
            search = decodeURIComponent(search);
        } catch (e) {
            console.error(e);
        }

        let href = search.match(/[?&]href(?:_[a-z0-9_\-]*)?=(.*?)(?:&|#|$)/);

        if (href && href[1] && href[1].charAt(0) === '/')
        {
            to = href[1];
            router.replace(href[1]).then();
        }
    }

    let resolved = router.resolve(to);

    if ('undefined' === typeof resolved.name &&
        (!resolved.matched || !resolved.matched.filter(match => !!match.redirect).length) || '/' === resolved.path)
    {
        // set route
        router.replace(exportDefaultRoute()).then();
    }
};